import clsx from 'clsx';
import type { QuarterlyData } from './periods';
import { getForecastContext } from './periods';
import { useTableSettings } from './TableSettingsContext';
import { formatCurrency } from './CurrencyDisplay';
import { RowLabel, type RowHint } from './RowHint';

interface SubtotalRowProps {
  label: string;
  hint?: RowHint | null;
  data: QuarterlyData;
  className?: string;
}

export function SubtotalRow({ label, hint, data, className }: SubtotalRowProps) {
  const { settings } = useTableSettings();
  const allQuarters = settings ? getForecastContext(settings).allQuarters : [];

  return (
    <tr className={clsx('border-t border-gray-400', className)}>
      <td className="sticky left-0 z-10 bg-white px-3 py-1.5 text-sm font-semibold text-gray-800 border-r border-b border-gray-300">
        <RowLabel label={label} hint={hint} />
      </td>
      {allQuarters.map((q) => {
        const value = data[q] ?? 0;
        return (
          <td
            key={q}
            className={clsx(
              'px-3 py-1.5 text-right text-sm tabular-nums font-semibold border-r border-b border-gray-300',
              'bg-gray-50',
              value === 0 ? 'text-gray-400' : value < 0 ? 'text-red-600' : 'text-gray-900',
            )}
          >
            {value === 0 ? '-' : formatCurrency(value)}
          </td>
        );
      })}
    </tr>
  );
}
